module.exports = __webpack_public_path__ + "static/media/bcom-management_LR.82e08e98.jpg";